import { Dispatch } from "../../controller";
import { Model,StateProps } from "../../model";
import { Pessoa,TipoPessoa } from "../../data.types";

export const statusFuncionario:string[] = [
    "Disponivel","Almoço","Descanço","Rota","Ferias"
]

export interface FuncionarioRules {
    alterar_preco_item_venda:boolean
}

export interface Funcionario extends Pessoa {
    admissao:string;
    demissao:string;
    status:string;
    rules?:FuncionarioRules
}

export interface FuncionarioState extends StateProps<Funcionario> {
    funcLogado:Funcionario
}

export interface FuncionarioActions extends Dispatch<Funcionario> {
    setFuncLogado:(func:Funcionario)=>any
    logout:()=>any
}

const model = new Model<Pessoa,FuncionarioState>(TipoPessoa.funcionario);

const intialValueFuncionario:Funcionario = {
    ...model.getInitialValue(),
    type:TipoPessoa.funcionario,
    apelido:"",
    nome:"",
    sobrenome:"",
    email:"",
    tipo_doc:"CPF",
    enderecos:[],
    idx_endereco_main:0,
    fone:"",
    n_doc:"",
    senha:"",
    whatsapp:"",
    admissao:"",
    demissao:"",
    ativo:true,
    status:statusFuncionario[0],
    rules:{
        alterar_preco_item_venda:false
    }
}

export const initialValueState:FuncionarioState = {
    ...model.getInititalValueState(),
    row:intialValueFuncionario,
    funcLogado:{} as Funcionario
}


